import React, { useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { baseUrl, url } from "../../Constant";
import { useEffect } from "react";
import { useAuth } from "../../Context/AuthProvider";
import { toast } from "react-toastify";
// import AddExtensionModal from "./Modal/AddExtensionModal";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import { useNavigate } from "react-router-dom";
// import BulkUploadModal from "./Modal/BulkUploadModal";
import { Search } from "@carbon/icons-react";

const customStyles = {
  pagination: {
    style: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
};

const SuperAdminExtensionsDetails = () => {
  const accessVpbxId = sessionStorage.getItem("companyData");
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [extensionData, setExtensionData] = useState();
  const [openAddExtensionModal, setEpenAddExtensionModal] = useState(false);
  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(0);
  const [apicalled, setApicalled] = useState(false);
  const [loader, setLoader] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const { auth } = useAuth();
  const [csvContent, setCsvContent] = useState("");
  const [size, setSize] = useState(10);
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const postExClient = process.env.REACT_APP_POSTEX_VPBX;
  const leopardClient = process.env.REACT_APP_LEOPARD_VPBX;
  const columns = [
    {
      name: "SERIES",
      selector: (row) => row.id,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_number,
    },
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.username,
    },
    {
      name: "CONSUMED MINUTES",
      selector: (row) => row.conusmed_min,
    },
    {
      name: "STATUS",
      // selector: (row) => row.status,
      selector: (row) => (
        <div>
          <button
            className={
              row.status == 1 ? "btn-design greenColor" : "btn-design redColor"
            }
            disabled={true}
            // onClick={() => handleStatus(row.username, row.status)}
          >
            {row.status == 1 ? "Activated" : "De-Activated"}
          </button>
        </div>
      ),
    },
    {
      name: "Incoming",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className={
                row.is_inbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              disabled={true}
              // onClick={() => handleStatusUpdate(row, "inbound")}
            >
              {row.is_inbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    {
      name: "Outgoing",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className={
                row.is_outbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              disabled={true}
              // onClick={() => handleStatusUpdate(row, "outbound")}
            >
              {row.is_outbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    // {
    //   name: "",
    //   cell: (row) => (
    //     <div
    //       className="uk-float-right"
    //       style={{ "text-align": "end", width: "100%" }}
    //     >
    //       <div className="uk-inline">
    //         <button
    //           className="iconTble actionDropDownBtn TableActionIcon"
    //           type="button"
    //           onClick={() => {
    //             // (window.location.href = `/edit-extension/${row.extension_number}`)
    //             window.location.href =
    //               auth.role === "3" ? "/edit-extensions" : `/edit-extension`;
    //             sessionStorage.setItem("extesnion", row.extension_number);
    //           }}
    //         >

    //           <span uk-icon="icon: pencil"></span>
    //         </button>

    //       </div>
    //     </div>
    //   ),
    // },
  ];
  const columnsWithPermissions = [
    {
      name: "SERIES",
      selector: (row) => row.id,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_number,
    },
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.username,
    },
    {
      name: "CONSUMED MINUTES",
      selector: (row) => row.conusmed_min,
    },
  ];

  const columns_for_template1 = [
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.extension_number,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_code,
    },
    {
      name: "Bucket",
      selector: (row) => row.allocated_package,
    },
    {
      name: "B-100",
      selector: (row) => row.b_1oo,
    },
    {
      name: "B-500",
      selector: (row) => row.b_5oo,
    },
    {
      name: "REMAINING MINUTES",
      selector: (row) =>
        row.remaining_minutes === "" ? "-" : row.remaining_minutes,
    },

    {
      name: "UTLIZED MINUTES",
      selector: (row) => row.consumed_minutes,
    },
    {
      name: "Incoming",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className={
                row.is_inbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              onClick={() => handleStatusUpdate(row, "inbound")}
            >
              {row.is_inbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    {
      name: "Outgoing",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className={
                row.is_outbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              onClick={() => handleStatusUpdate(row, "outbound")}
            >
              {row.is_outbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className="activation"
              type="button"
              // disabled={row.remaining_minutes !== 0}
              onClick={() => handleQuotaUpdate(row, row.button_1)}
            >
              {row.button_1}
            </button>
          </div>
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              className="activation"
              type="button"
              // disabled={row.remaining_minutes !== 0}
              onClick={() => handleQuotaUpdate(row, row.button_2)}
            >
              {row.button_2}
            </button>
          </div>
        </div>
      ),
    },
  ];
  const columns_for_template1WithPermissions = [
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.extension_number,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_code,
    },
    {
      name: "Bucket",
      selector: (row) => row.allocated_package,
    },
    {
      name: "REMAINING MINUTES",
      selector: (row) =>
        row.remaining_minutes === "" ? "-" : row.remaining_minutes,
    },

    {
      name: "UTLIZED MINUTES",
      selector: (row) => row.consumed_minutes,
    },
  ];
  const columns_for_template2 = [
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.extension_number,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_code,
    },
    {
      name: "OnNet Bucket",
      selector: (row) => row.onnet_package,
    },
    {
      name: "OffNet Bucket",
      selector: (row) => row.offnet_package,
    },
    {
      name: "OnNet REMAINING MINUTES",
      selector: (row) =>
        row.onnet_remaining_minutes === "" ? "-" : row.onnet_remaining_minutes,
    },
    {
      name: "OffNet REMAINING MINUTES",
      selector: (row) =>
        row.offnet_remaining_minutes === ""
          ? "-"
          : row.offnet_remaining_minutes,
    },

    {
      name: "OnNet UTLIZED MINUTES",
      selector: (row) => row.on_net_consume_minutes,
    },
    {
      name: "OffNet UTLIZED MINUTES",
      selector: (row) => row.off_net_consume_minutes,
    },
    {
      name: "Incoming",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              disabled={true}
              className={
                row.is_inbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              onClick={() => handleStatusUpdate(row, "inbound")}
            >
              {row.is_inbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    {
      name: "Outgoing",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-flex">
            <button
              disabled={true}
              className={
                row.is_outbound == 1
                  ? "btn-design greenColor"
                  : "btn-design redColor"
              }
              type="button"
              onClick={() => handleStatusUpdate(row, "outbound")}
            >
              {row.is_outbound == 1 ? "Activated" : "De-Activated"}
            </button>
          </div>
        </div>
      ),
    },
    // {
    //   name: "",
    //   cell: (row) => (
    //     <div
    //       className="uk-float-right"
    //       style={{ "text-align": "end", width: "100%" }}
    //     >
    //       <div className="uk-flex">
    //         <button
    //           className="activation"
    //           type="button"
    //           // disabled={
    //           //   row.onnet_remaining_minutes === 0
    //           //     ? false
    //           //     : row.offnet_remaining_minutes === 0
    //           //     ? false
    //           //     : true
    //           // }
    //           onClick={() => handleQuotaUpdate(row, row.button_1)}
    //         >
    //           {row.button_1}
    //         </button>
    //       </div>
    //     </div>
    //   ),
    // },
    // {
    //   name: "",
    //   cell: (row) => (
    //     <div
    //       className="uk-float-right"
    //       style={{ "text-align": "end", width: "100%" }}
    //     >
    //       <div className="uk-flex">
    //         <button
    //           className="activation"
    //           type="button"
    //           // disabled={
    //           //   row.onnet_remaining_minutes === 0
    //           //     ? false
    //           //     : row.offnet_remaining_minutes === 0
    //           //     ? false
    //           //     : true
    //           // }
    //           onClick={() => handleQuotaUpdate(row, row.button_2)}
    //         >
    //           {row.button_2}
    //         </button>
    //       </div>
    //     </div>
    //   ),
    // },
  ];
  const columns_for_template2WithPermissions = [
    {
      name: "EXTENSION NUMBER",
      selector: (row) => row.extension_number,
    },
    {
      name: "CODE",
      selector: (row) => row.extension_code,
    },
    {
      name: "OnNet Bucket",
      selector: (row) => row.onnet_package,
    },
    {
      name: "OffNet Bucket",
      selector: (row) => row.offnet_package,
    },
    {
      name: "OnNet REMAINING MINUTES",
      selector: (row) =>
        row.onnet_remaining_minutes === "" ? "-" : row.onnet_remaining_minutes,
    },
    {
      name: "OffNet REMAINING MINUTES",
      selector: (row) =>
        row.offnet_remaining_minutes === ""
          ? "-"
          : row.offnet_remaining_minutes,
    },

    {
      name: "OnNet UTLIZED MINUTES",
      selector: (row) => row.on_net_consume_minutes,
    },
    {
      name: "OffNet UTLIZED MINUTES",
      selector: (row) => row.off_net_consume_minutes,
    },
  ];

  const handleOperation = (userName, Status) => {
    setLoader(true);

    axios
      .post(
        url + "operation-change",
        {
          vpbx_id: auth.vpbx_id,
          username: userName,
          status: Status == 0 ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(function (result) {
        if (result.data.status === true) {
          setLoader(false);
          toast.success("Operation Changed Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1200,
          });
          setTimeout(() => {
            window.location.href = "/extensions";
          }, 1500);
        }
      });
  };
  const handleQuotaUpdate = (data, quota) => {
    let api = "";
    if (auth.role === "2") {
      api = "update-outbound-quota";
    } else {
      api = "user-update-outbound-quota";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
          name: data.extension_number,
          extension_code: data.extension_code,
          outbound_quota: quota,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(function (result) {
        if (result.data.code === 200) {
          setTimeout(() => {
            toast.success("Operation Changed Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 1500);
          setTimeout(() => {
            window.location.href = "/extensions";
          }, 1500);
        } else {
          setTimeout(() => {
            toast.error(result.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 1500);
        }
      });
  };
  const handleStatusUpdate = (data, type) => {
    let dataForApi = {
      vpbx_id: auth.vpbx_id,
      extension: data.extension_number,
    };

    if (type === "inbound") {
      dataForApi["inbound_status"] = data.is_inbound == 1 ? 0 : 1;
    }
    if (type === "outbound") {
      dataForApi["outbound_status"] = data.is_outbound == 1 ? 0 : 1;
    }
    let api = "";
    if (auth.role === "2") {
      api = "update-extension-status";
    } else {
      api = "user-update-extension-status";
    }
    axios
      .post(url + api, dataForApi, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(function (result) {
        if (result.data.code === 200) {
          setTimeout(() => {
            toast.success("Extension status Changed Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 500);
          setTimeout(() => {
            getExtensions();
          }, 700);
        } else {
          setTimeout(() => {
            toast.error(result.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 1500);
        }
      });
  };

  const handleStatus = (userName, Status) => {
    setLoader(true);
    let api = "";
    if (auth.role === "2") {
      api = "status-change";
    } else {
      api = "user-status-change";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
          username: userName,
          status: Status == 0 ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(function (result) {
        if (result.data.status === true) {
          setLoader(false);
          toast.success("Status Changed Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1200,
          });
          setTimeout(() => {
            window.location.href = "/extensions";
          }, 1500);
        }
      });
  };
  const getExtensions = () => {
    var apiParam = "";
    setLoader(true);
    if (auth.role === "1") {
      apiParam =
        sessionStorage.getItem("template_id") === "0"
          ? "super-get-extensions"
          : "super-view-extensions";
    } else if (auth.role === "2") {
      apiParam =
        auth.is_templete === "0" ? "get-extensions" : "view-extensions";
    } else {
      apiParam =
        auth.is_templete === "0"
          ? "user-get-extensions"
          : "user-view-extensions";
    }

    var data = {
      vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
    };

    // Add pagination parameters for PostEx client
    if (postExClient === auth.vpbx_id || leopardClient === auth.vpbx_id) {
      data["page"] = currentPage;
      data["limit"] = rowsPerPage;
      data["search"] = searchText;
    }

    axios
      .post(url + apiParam, data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setApicalled(false);
          setLoader(false);

          if (
            response.data.message === "Data Not Found" &&
            response.data.data.length === 0
          ) {
            setExtensionData([]);
          } else if (response.data.message === "Data Found") {
            // For PostEx client, expect the API to return paginated data
            if (
              postExClient === auth.vpbx_id ||
              leopardClient === auth.vpbx_id
            ) {
              setExtensionData(response.data.data);
              setTotalPages(response.data.pages);
            } else {
              setExtensionData(response.data.data);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (auth.vpbx_id !== postExClient && auth.vpbx_id !== leopardClient) {
      getExtensions();
    }
  }, []);
  useEffect(() => {
    if (apicalled === true) {
      getExtensions();
    }
  }, [apicalled]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (auth.vpbx_id === postExClient || auth.vpbx_id === leopardClient) {
      getExtensions();
    }
  }, [currentPage, searchText, rowsPerPage]);
  const handleRowsPerPageChange = (newRowsPerPage, page) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(page);
  };

  const dataTableProps = {
    pagination: true,
    paginationServer:
      postExClient === auth.vpbx_id || leopardClient === auth.vpbx_id,
    paginationTotalRows:
      postExClient === auth.vpbx_id || leopardClient === auth.vpbx_id
        ? totalPages
        : extensionData?.length,
    paginationDefaultPage: currentPage,
    paginationPerPage: rowsPerPage,
    paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handleRowsPerPageChange,
  };

  const filteredDataExtensionsDetails = extensionData?.filter((val) => {
    return (
      (val?.id &&
        typeof val.id === "string" &&
        val?.id.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.extension_number &&
        typeof val.extension_number === "string" &&
        val.extension_number
          .toLowerCase()
          .includes(searchText.toLowerCase())) ||
      (val?.username &&
        typeof val?.username === "string" &&
        val.username.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.conusmed_min &&
        typeof val.conusmed_min === "string" &&
        val.conusmed_min.toLowerCase().includes(searchText.toLowerCase()))
    );
  });
  const filteredDataExtensionsDetailsTemplate = extensionData?.filter((val) => {
    return (
      (val?.extension_code &&
        typeof val?.extension_code === "string" &&
        val?.extension_code.toLowerCase().includes(searchText.toLowerCase())) ||
      (val?.extension_number &&
        typeof val?.extension_number === "string" &&
        val?.extension_number.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    // console.log("Exporting data...");
    // const exportedDataTemplate1 = filteredDataExtensionsDetailsTemplate.map(
    //   (val) => ({
    //     "EXTENSION NUMBER": val.extension_number,
    //     CODE: val.extension_code,
    //     Bucket: val.allocated_package,
    //     "REMAINING MINUTES": val.remaining_minutes,
    //     "UTLIZED MINUTES": val.consumed_minutes,
    //   })
    // );

    // const exportedDataTemplate2 = filteredDataExtensionsDetailsTemplate.map(
    //   (val) => ({
    //     "EXTENSION NUMBER": val.extension_number,
    //     CODE: val.extension_code,
    //     "OnNet Bucket": val.onnet_package,
    //     "OffNet Bucket": val.offnet_package,
    //     "OnNet REMAINING MINUTES": val.onnet_remaining_minutes,
    //     "OffNet REMAINING MINUTES": val.offnet_remaining_minutes,
    //     "OnNet UTLIZED MINUTES": val.on_net_consume_minutes,
    //     "OffNet UTLIZED MINUTES": val.off_net_consume_minutes,
    //   })
    // );
    // const exportedData =
    //   (auth.is_templete === "1" && exportedDataTemplate1) ||
    //   (auth.is_templete === "2" && exportedDataTemplate2);
    // const csvContent =
    //   "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    // const jsonData = JSON.stringify(exportedData, null, 2);

    setExportLoader(true);

    axios
      .post(
        `${baseUrl}super-export-extensions`,
        {
          vpbx_id: accessVpbxId,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          window.location.href = response.data.data;
          setExportLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        setExportLoader(false);
      });
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  const handleAddExtension = () => {
    setEpenAddExtensionModal(true);
  };
  const handleCloseExtension = () => {
    setEpenAddExtensionModal(false);
  };
  const handleOpenBulkModal = () => {
    setOpenBulkModal(true);
  };
  const handleCloseBulkModal = () => {
    setOpenBulkModal(false);
  };

  useEffect(() => {
    if (extensionData !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      console.log(paginationNav);
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)",
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [extensionData]);

  return (
    <div className="ImcomingCallMain RoutingMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-1">
          <div className="uk-text-left">
            <div className="uk-flex uk-flex-between">
              <div className="CustomSearch">
                <form
                  className="uk-search uk-search-default uk-flex uk-flex-between"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSearchText(searchInput);
                  }}
                >
                  <input
                    className="uk-search-input"
                    type="text"
                    placeholder="Search by code and extension #"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <button
                    type="submit"
                    className=" uk-button uk-button-small "
                    style={{
                      marginLeft: "10px",
                      padding: "0px 15px",
                      marginTop: "5px",
                    }}
                  >
                    <Search color="#e40077" size={20} />
                  </button>
                </form>
              </div>
              {/* <div className="uk-flex-right">
                                {(auth.is_templete === "1" ||
                                  auth.is_templete === "2" ||
                                  (auth.role === "3" &&
                                    checkIndividualPermission(
                                      "extensions",
                                      "read_and_write"
                                    ))) && (
                                  <>
                                    <button
                                      className="exportData-button"
                                      onClick={handleExportData}
                                    >
                                      Export Data
                                    </button>
                                    <button
                                      className="exportData-button"
                                      onClick={handleAddExtension}
                                    >
                                      Add
                                    </button>
                                  </>
                                )}
                              </div> */}

              <div className="uk-flex-right">
                {auth.role === "3" ? (
                  checkIndividualPermission("extensions", "read_and_write") &&
                  (sessionStorage.getItem("template_id") === "1" ||
                    sessionStorage.getItem("template_id") === "2") ? (
                    <>
                      <button
                        className="exportData-button"
                        onClick={handleExportData}
                      >
                        Export Data
                      </button>
                      <button
                        className="exportData-button"
                        onClick={handleAddExtension}
                      >
                        Add
                      </button>
                    </>
                  ) : null
                ) : sessionStorage.getItem("template_id") === "1" ||
                  sessionStorage.getItem("template_id") === "2" ? (
                  <>
                    {/* <button
                      className="exportData-button"
                      onClick={handleOpenBulkModal}
                    >
                      Add bulk
                    </button> */}
                    <button
                      className="exportData-button"
                      onClick={handleExportData}
                      disabled={exportLoader}
                    >
                      {exportLoader ? "Loading..." : "Export Data"}
                    </button>
                    {/* <button
                      className="exportData-button"
                      onClick={handleAddExtension}
                    >
                      Add
                    </button> */}
                  </>
                ) : null}
              </div>
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
      <div>
        {loader ? (
          <div uk-spinner="" className="tableloader"></div>
        ) : (
          (sessionStorage.getItem("template_id") === "0" && (
            <DataTable
              columns={
                auth.role === "3" &&
                !checkIndividualPermission("extensions", "read_and_write")
                  ? columnsWithPermissions
                  : columns
              }
              data={
                auth.vpbx_id === postExClient || auth.vpbx_id === leopardClient
                  ? extensionData
                  : filteredDataExtensionsDetails
              }
              // pagination
              customStyles={customStyles}
              {...dataTableProps} // Spread the pagination props
            />
          )) ||
          (sessionStorage.getItem("template_id") === "1" && (
            <DataTable
              className="leapordExtension"
              columns={
                auth.role === "3" &&
                !checkIndividualPermission("extensions", "read_and_write")
                  ? columns_for_template1WithPermissions
                  : columns_for_template1
              }
              data={
                auth.vpbx_id === postExClient || auth.vpbx_id === leopardClient
                  ? extensionData
                  : filteredDataExtensionsDetailsTemplate
              }
              // pagination
              customStyles={customStyles}
              {...dataTableProps} // Spread the pagination props
            />
          )) ||
          (sessionStorage.getItem("template_id") === "2" && (
            <DataTable
              className="leapordExtension"
              columns={
                auth.role === "3" &&
                !checkIndividualPermission("extensions", "read_and_write")
                  ? columns_for_template2WithPermissions
                  : columns_for_template2
              }
              data={
                auth.vpbx_id === postExClient || auth.vpbx_id === leopardClient
                  ? extensionData
                  : filteredDataExtensionsDetailsTemplate
              }
              // pagination
              {...dataTableProps} // Spread the pagination props
              customStyles={customStyles}
            />
          ))
        )}
      </div>
      {/* {openAddExtensionModal && (
                        <AddExtensionModal
                          closeModal={handleCloseExtension}
                          setApicalled={setApicalled}
                        />
                      )} */}
      {/* {openBulkModal && (
                        <BulkUploadModal
                          closeModal={handleCloseBulkModal}
                          setApicalled={setApicalled}
                        />
                      )} */}
    </div>
  );
};

export default SuperAdminExtensionsDetails;
